if (window.Form == null) {
  window.Form = {};
}
window.Form.FieldCounter = class FieldCounter {
  static characterCount(input) {
    return jQuery(input).val().length;
  }

  static decorate(inputs) {
    return jQuery(inputs).each((_, input) => {
      input = jQuery(input);
      let counter = input.data("fieldCounter");

      if (counter) {
        return counter.render();
      }

      const options = {
        hardMax: input.attr("maxlength"),
        hardMin: input.attr("minlength"),
        max: input.data("recommended-max") || input.attr("maxlength"),
        min: input.data("recommended-min") || input.attr("minlength"),
        message: input.data("recommended-message"),
      };
      counter = new this(input, options).render();

      // Append to the field label
      return counter.el.appendTo(input.closest(".field").find(".field-label"));
    });
  }

  constructor(input, options) {
    this.render = this.render.bind(this);
    this.counterElement = this.counterElement.bind(this);
    this.messageElement = this.messageElement.bind(this);
    this.getCount = this.getCount.bind(this);
    this.displayTarget = this.displayTarget.bind(this);
    this.initBounds = this.initBounds.bind(this);
    this.hasBounds = this.hasBounds.bind(this);
    this.isHardBounded = this.isHardBounded.bind(this);
    this.input = input;
    this.options = jQuery.extend(
      {
        justRight: "Good",
        tooLong: "Too Long",
        tooShort: "Too Short",
        counter: this.constructor.characterCount,
        threshold: 0,
        min: 0,
        hardMin: 0,
        show: "max",
        message: true,
      },
      options,
    );

    this.initBounds();

    this.el = jQuery('<span class="field-counter">');
    jQuery(this.input).data("fieldCounter", this); // Store the counter on the input in case we want to access it

    // BEHAVIOUR

    jQuery(this.input).on("input change", this.render);
  }

  render() {
    const count = this.getCount();
    this.el.html([this.counterElement(count), " ", this.messageElement(count)]);

    return this;
  }

  counterElement(count) {
    if (this.hasBounds()) {
      count = `${count} / ${this.displayTarget()}`;
    }
    return `<span class='count'>${count}</span>`;
  }

  messageElement(count) {
    let cssClass;
    let text;
    if (!this.hasBounds() || !this.options.message) {
      return;
    }
    if (this.isHardBounded()) {
      return;
    }

    if (this.options.min <= count && count <= this.options.max) {
      text = this.options.justRight;
      cssClass = "just-right";
    } else if (this.options.min > count) {
      text = this.options.tooShort;
      cssClass = "too-short";
    } else {
      text = this.options.tooLong;
      cssClass = "too-long";
    }

    if (text) {
      return `<span class='message ${cssClass}'>${text}</span>`;
    }
  }

  getCount() {
    return this.options.counter(this.input);
  }

  displayTarget() {
    switch (this.options.show) {
      case "max":
        return this.options.max;
      case "min":
        return this.options.min;
      case "target":
        return this.options.target;
    }
  }

  initBounds() {
    if (this.options.target && this.options.max == null) {
      this.options.max = this.options.target + this.options.threshold;
    }
    if (this.options.target && this.options.min == null) {
      return (this.options.min = this.options.target - this.options.threshold);
    }
  }

  hasBounds() {
    return this.options.min != null && this.options.max != null;
  }

  isHardBounded() {
    return this.options.hardMax === this.options.max && this.options.hardMin === this.options.min;
  }
};
